import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Lenis from "lenis";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { StickyBar } from "@/components/StickyBar";
import { CookieBanner } from "@/components/CookieBanner";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import ZonesPage from "@/pages/ZonesPage";
import AboutPage from "@/pages/AboutPage";
import DevisPage from "@/pages/DevisPage";
import ContactPage from "@/pages/ContactPage";
import { MentionsLegales, Confidentialite, CookiesPage } from "@/pages/LegalPages";
import NotFound from "@/pages/NotFound";

gsap.registerPlugin(ScrollTrigger);

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    ScrollTrigger.refresh();
  }, [pathname]);
  return null;
};

const SmoothScroll = () => {
  useEffect(() => {
    // Le smooth-scroll (Lenis) remplace le scroll natif par un recalcul JS a
    // chaque frame - utile pour l'effet "fluide" au trackpad/souris, mais
    // ca alourdit inutilement le scroll tactile (deja fluide nativement sur
    // mobile) et etait la premiere cause de lenteur ressentie sur telephone.
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (window.matchMedia("(pointer: coarse)").matches) return;
    const lenis = new Lenis({ autoRaf: false, lerp: 0.12 });
    lenis.on("scroll", ScrollTrigger.update);
    const raf = (time) => lenis.raf(time * 1000);
    gsap.ticker.add(raf);
    gsap.ticker.lagSmoothing(0);
    return () => {
      gsap.ticker.remove(raf);
      lenis.destroy();
    };
  }, []);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <SmoothScroll />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ravalement-facade" element={<ServicePage slug="ravalement-facade" />} />
            <Route path="/nettoyage-hydrofuge" element={<ServicePage slug="nettoyage-hydrofuge" />} />
            <Route path="/peinture" element={<ServicePage slug="peinture" />} />
            <Route path="/carrelage-maconnerie" element={<ServicePage slug="carrelage-maconnerie" />} />
            <Route path="/zones-intervention" element={<ZonesPage />} />
            <Route path="/a-propos" element={<AboutPage />} />
            <Route path="/devis" element={<DevisPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/politique-confidentialite" element={<Confidentialite />} />
            <Route path="/cookies" element={<CookiesPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <StickyBar />
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
